import React from 'react';
import { ImageCol } from '@/components/ImageCol';
import {
    ImageContentCol,
    IMAGE_CONTENT_COL_SPACING
} from '@/components/ImageContentCol';
import RenderDotPoints from '@/components/RenderDotPoints';
import RenderParagraphs from '@/components/RenderParagraphs';
import { useTranslationHook } from '@/hooks/useTranslationHook';

const AdministrativeSection = () => {
    const { translate } = useTranslationHook();

    return (
        <div className='mt-4' id='top'>
            <ImageContentCol title={translate('administrativeTitle')}
                             spacing={IMAGE_CONTENT_COL_SPACING.NONE}
                             leftContent={
                                 <>
                                     <RenderParagraphs translateLabel='administrativeParagraphs'/>
                                     <h5>{translate('administrativeSubTitle')}</h5>
                                     <RenderDotPoints translateLabel='administrativeItemList'/>
                                 </>
                             }
                             rightContent={
                                 <div className='job-seeker-image'>
                                     <ImageCol src={'core-staff-administrative.png'}
                                               alt={'standing-workers'}/>
                                 </div>
                             }
            />

        </div>
    );
};

export default AdministrativeSection;